<template>
    <label
        :for="id"
        :tabindex="labelCanBeFocused && answerData.type !== `Description` ? 0 : false"
        @focus="focusForKeyboardNavigation"
        :data-has-description="showDescription"
        :id="`question-${questionData.number}_label-${answerData.number}`"
        :aria-hidden="ariaHidden"
    >
        <span data-label v-html="DOMPurify.sanitize(answerData.label)"></span>
        <span
			data-asterisk
			v-if="answerData.validation.required === true"
		>*</span>
        <answerdescription
            v-if="showDescription"
            data-has-description-text
            :answerData="answerData"
            :questionData="questionData"
        />
    </label>
</template>

<script>
import answerdescription from "@/components/AnswerDescription";

export default {
    inject: ['DOMPurify'],
    name: `answer-label`,
    data() {
        return {};
    },
    components: {
        answerdescription,
    },
    props: {
        // The data of the answer that this inputfield is part of
        answerData: {
            type: Object,
        },
        ariaHidden: {
            type: Boolean,
            default: false,
        },
        showDescription: {
            type: Boolean,
            default: false,
        },
        // Is the label allowed to be focusable. This is useful for when navigating a page with a keyboard
        labelCanBeFocused: {
            type: Boolean,
            default: false,
        },
        // The data of the question that this inputfield is part of
        questionData: {},
    },
    computed: {
        id: function () {
            if (this.answerData.type == `Radiobutton` || this.answerData.type == `Checkbox` || this.answerData.type == `Description`) {
                return `question-${this.questionData.number}_checkradio-answer-${this.answerData.number}`;
            } else return `question-${this.questionData.number}_checkradio-input-answer-${this.answerData.number}`;
        },
    },
    methods: {
        // This is used to make elements navigable by keyboard. Without an tabindex this event won't be triggered
        focusForKeyboardNavigation: function (e) {
            e.target.click();
        },
    },
};
</script>
<style scoped>
label {
    font-size: 16px;
    width: 100%;
}

[data-label] {
    max-width: 100%;
    min-width: 10%;
}

[data-has-description] {
    display: flex;
    align-items: center;
    [data-label] {
        margin-right: 3px;
        min-width: initial;
    }
}

[data-sr-type="image-and-text"] [data-has-description] {
    > span {
        margin-right: 3px;
    }
}

[data-has-description-text] {
    margin-left: auto;
}
</style>
